import React from "react";

export interface Mark {
  s: number;
  e: number;
}

export function HighlightedText({
  text,
  marks,
}: {
  text: string;
  marks: Mark[] | undefined;
}) {
  if (!marks || marks.length === 0) return <>{text}</>;
  // s/e are Unicode code point offsets (from Python string indexing on the backend), not UTF-16
  // code unit offsets - slice via Array.from so multi-byte emoji don't throw the offsets off.
  const chars = Array.from(text);
  const parts: React.ReactNode[] = [];
  let pos = 0;
  for (const { s, e } of marks) {
    if (s > pos) parts.push(chars.slice(pos, s).join(""));
    parts.push(<mark key={s}>{chars.slice(s, e).join("")}</mark>);
    pos = e;
  }
  if (pos < chars.length) parts.push(chars.slice(pos).join(""));
  return <>{parts}</>;
}
